<template>
  <div>
    <div class="page flex ai-s">
      <div class="leftBox">
        <div v-if="detailInfo != null">
          <div class="prediction">
            <div class="predictionBox">
              <div class="head flex flex-pack-justify flex-align-center">
                <div class="flex flex-align-center">
                  <i class="poissonIcon" />
                  <div class="title">Poisson Predicted Final Scores</div>
                </div>
                <i class="queryIcon" @click="showPopup()"/>
              </div>
              <ul class="resultsBox flex">
                <li v-for="(item,index) in detailInfo.scoreModel.scoreTopOptions" :key="index">
                  <div class="score flex flex-align-center" :class="isHit(item.isHit)">{{ item.score == '1d' ? 'Others' : item.score }} <i v-if="item.isHit == 1" class="active"/></div>
                  <div class="percentage">{{ item.value }}%</div>
                  <div class="odds">odds {{ item.odds == 0 ? '-' : item.odds }}</div>
                </li>
              </ul>
            </div>
          </div>
          <div class="logged" style="clear: both" v-if="isLogin == true || match.state == 4">
            
            <!-- 比分概率分布 -->
            <div class="scoreProbability" v-if="detailInfo.scoreModel.hasOwnProperty('scoreTotalOptions')">
              <div class="title">Correct Score Probabilities</div>
              <ul class="scoreProbabilityBox flex flex-warp">
                <li v-for="(item,index) in scoreProbabilityArr" :key="index" class="flex flex-align-center">
                  <div class="leftBox">{{item == '1d' ? 'Others' : item}}</div>
                  <div class="rightBox">
                    <div class="percentage">{{getscoreProbabilityValue('val',item) ? getscoreProbabilityValue('val',item) + '%' : ''}}</div>
                    <div class="odds">{{getscoreProbabilityValue('odds',item)}}</div>
                  </div>
                </li>
              </ul>
            </div>

            <!-- 近10场主客场统计 1-->
          <div class="last10Games">
            <div class="title">Home/Away Statistics (Last 10 Matches)</div>
            <div class="last10GamesBox">
              <div class="container">
                <div class="flex flex-pack-justify">
                  <div class="homeTile"><span>{{ detailInfo.match.homeTeam.shortName }}</span> Home</div>
                  <div class="awayTile"><span>{{ detailInfo.match.awayTeam.shortName }}</span> Away</div>
                </div>
                <div v-if="detailInfo.scoreModel.hasOwnProperty('last_10Goals')">
                  <!-- 进球数 -->
                  <div>
                    <div class="flex flex-pack-justify flex-align-center">
                      <div class="val">{{ detailInfo.scoreModel.last_10Goals.home.goals}}</div>
                      <div class="name">Goals</div>
                      <div class="val">{{ detailInfo.scoreModel.last_10Goals.away.goals }}</div>
                    </div>
                    <div class="flex progress">
                      <div class="left" >
                        <div class="left_active" :style=" 'width:' + percentageVal((Number(detailInfo.scoreModel.last_10Goals.home.goals) + Number(detailInfo.scoreModel.last_10Goals.away.goals)), detailInfo.scoreModel.last_10Goals.home.goals) "></div>
                      </div>
                      <div class="middle"></div>
                      <div class="right">
                        <div class="right_active" :style=" 'width:' + percentageVal((Number(detailInfo.scoreModel.last_10Goals.home.goals) + Number(detailInfo.scoreModel.last_10Goals.away.goals)), detailInfo.scoreModel.last_10Goals.away.goals) "></div>
                      </div>
                    </div>
                  </div>
                  <!-- 失球数 -->
                  <div>
                    <div class="flex flex-pack-justify flex-align-center">
                      <div class="val">{{ detailInfo.scoreModel.last_10Goals.home.loss }}</div>
                      <div class="name">Goals Conceded</div>
                      <div class="val">{{ detailInfo.scoreModel.last_10Goals.away.loss }}</div>
                    </div>
                    <div class="flex progress">
                      <div class="left" >
                        <div class="left_active" :style=" 'width:' + percentageVal((Number(detailInfo.scoreModel.last_10Goals.home.loss) + Number(detailInfo.scoreModel.last_10Goals.away.loss)), Number(detailInfo.scoreModel.last_10Goals.home.loss)) "></div>
                      </div>
                      <div class="middle"></div>
                      <div class="right">
                        <div class="right_active" :style=" 'width:' + percentageVal((Number(detailInfo.scoreModel.last_10Goals.home.loss) + Number(detailInfo.scoreModel.last_10Goals.away.loss)), Number(detailInfo.scoreModel.last_10Goals.away.loss)) "></div>
                      </div>
                    </div>
                  </div>
                  <!-- 胜率 -->
                  <div>
                    <div class="flex flex-pack-justify flex-align-center">
                      <div class="val">{{ detailInfo.scoreModel.last_10Goals.home.winPct }}%</div>
                      <div class="name">Win Rate</div>
                      <div class="val">{{ detailInfo.scoreModel.last_10Goals.away.winPct }}%</div>
                    </div>
                    <div class="flex progress">
                      <div class="left" >
                        <div class="left_active" :style="'width:' + detailInfo.scoreModel.last_10Goals.home.winPct + '%'"></div>
                      </div>
                      <div class="middle"></div>
                      <div class="right">
                        <div class="right_active" :style="'width:' + detailInfo.scoreModel.last_10Goals.away.winPct + '%'"></div>
                      </div>
                    </div>
                  </div>
                  <!-- 平局率 -->
                  <div>
                    <div class="flex flex-pack-justify flex-align-center">
                      <div class="val">{{ detailInfo.scoreModel.last_10Goals.home.platPct }}%</div>
                      <div class="name">Draw Rate</div>
                      <div class="val">{{ detailInfo.scoreModel.last_10Goals.away.platPct }}%</div>
                    </div>
                    <div class="flex progress">
                      <div class="left" >
                        <div class="left_active" :style="'width:' + detailInfo.scoreModel.last_10Goals.home.platPct + '%'"></div>
                      </div>
                      <div class="middle"></div>
                      <div class="right">
                        <div class="right_active" :style="'width:' + detailInfo.scoreModel.last_10Goals.away.platPct + '%'"></div>
                      </div>
                    </div>
                  </div>
                  <!-- 场均角球 -->
                  <div>
                    <div class="flex flex-pack-justify flex-align-center">
                      <div class="val">{{ detailInfo.scoreModel.last_10Goals.home.corners }}</div>
                      <div class="name">Corners per game</div>
                      <div class="val">{{ detailInfo.scoreModel.last_10Goals.away.corners }}</div>
                    </div>
                    <div class="flex progress">
                      <div class="left" >
                        <div class="left_active" :style=" 'width:' + percentageVal((Number(detailInfo.scoreModel.last_10Goals.home.corners) + Number(detailInfo.scoreModel.last_10Goals.away.corners)), Number(detailInfo.scoreModel.last_10Goals.home.corners)) "></div>
                      </div>
                      <div class="middle"></div>
                      <div class="right">
                        <div class="right_active" :style=" 'width:' + percentageVal((Number(detailInfo.scoreModel.last_10Goals.home.corners) + Number(detailInfo.scoreModel.last_10Goals.away.corners)), Number(detailInfo.scoreModel.last_10Goals.away.corners)) "></div>
                      </div>
                    </div>
                  </div>
                  <!-- 场均射门 -->
                  <div>
                    <div class="flex flex-pack-justify flex-align-center">
                      <div class="val">{{ detailInfo.scoreModel.last_10Goals.home.shots }}</div>
                      <div class="name">Shots per game</div>
                      <div class="val">{{ detailInfo.scoreModel.last_10Goals.away.shots }}</div>
                    </div>
                    <div class="flex progress">
                      <div class="left" >
                        <div class="left_active" :style=" 'width:' + percentageVal((Number(detailInfo.scoreModel.last_10Goals.home.shots) + Number(detailInfo.scoreModel.last_10Goals.away.shots)), Number(detailInfo.scoreModel.last_10Goals.home.shots)) "></div>
                      </div>
                      <div class="middle"></div>
                      <div class="right">
                        <div class="right_active" :style=" 'width:' + percentageVal((Number(detailInfo.scoreModel.last_10Goals.home.shots) + Number(detailInfo.scoreModel.last_10Goals.away.shots)), Number(detailInfo.scoreModel.last_10Goals.away.shots)) "></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

            <!-- 过往交锋赛果 -->
            <div class="pastConfrontationResult" v-if="detailInfo.scoreModel.hasOwnProperty('scoreTotalOptions') && detailInfo.scoreModel.scoreLastLog.length > 3">
              <div class="title">Head-to-Head Results History </div>
              <div class="pastConfrontationResultBox">
                <div class="flex flex-align-center">
                  <div class="title">H</div>
                  <ul class="flex">
                    <li v-for="(item,index) in detailInfo.scoreModel.scoreLastLog" :key="index" >
                      <!-- <div v-if="detailInfo.scoreModel.scoreSameLastLog.find(ele => ele.time == item.time)" class="result" :class="item.res == 1 ? 'win' : item.res == 2 ? 'draw' : 'lose'">{{item.score}}</div>
                      <div v-if="!(detailInfo.scoreModel.scoreSameLastLog.find(ele => ele.time == item.time))" class="result">{{item.score}}</div> -->
                      <div v-if="item.isH == true" class="result" :class="item.res == 1 ? 'win' : item.res == 2 ? 'draw' : 'lose'">{{item.score}}</div>
                      <div v-if="item.isH == false" class="result">{{item.score}}</div>
                    </li>
                  </ul>
                </div>
                <div class="last flex flex-align-center">
                  <div>Last</div>
                  <i  class="rightArrow"/>
                </div>
                <div class="flex flex-align-center">
                  <div class="title">A</div>
                  <ul class="flex">
                    <li v-for="(item,index) in detailInfo.scoreModel.scoreLastLog" :key="index" >
                      <!-- <div v-if="!(detailInfo.scoreModel.scoreSameLastLog.find(ele => ele.time == item.time))" class="result" :class="item.res == 1 ? 'win' : item.res == 2 ? 'draw' : 'lose'">{{item.isH == true ? item.homeScore + '-' + item.awayScore : item.awayScore + '-' + item.homeScore}}</div> -->
                      <!-- <div v-if="!(detailInfo.scoreModel.scoreSameLastLog.find(ele => ele.time == item.time))" class="result" :class="(item.res == 1&&item.isH == true || item.res == 3&&item.isH == false) ? 'win' : (item.res == 3&&item.isH == true || item.res == 1&&item.isH == false) ? 'lose' : 'draw'">{{item.isH == true ? item.homeScore + '-' + item.awayScore : item.awayScore + '-' + item.homeScore}}</div>
                      <div v-if="detailInfo.scoreModel.scoreSameLastLog.find(ele => ele.time == item.time)" class="result">{{item.score}}</div> -->
                      <div v-if="item.isH == false" class="result" :class="item.res == 3 ? 'win' : item.res == 2 ? 'draw' : 'lose'">{{item.isH == true ? item.homeScore + '-' + item.awayScore : item.awayScore + '-' + item.homeScore}}</div>
                      <div v-if="item.isH == true" class="result">{{item.score}}</div>
                    </li>
                  </ul>
                </div>
                <div>
                  <div class="iconLine flex flex-pack-justify ">
                      <span class="win">Win</span>
                      <span class="draw">Draw</span>
                      <span class="lose">Loss</span>
                  </div>
                  <div class="tip">Note: The first row is for the home team playing at home, and the second row is for the home team playing away.</div>
                </div>
              </div>
            </div>
          </div>

          <!-- 未登录 -->
          <div class="noLogin" v-if="isLogin == false && match.state != 4">
            <!-- <img src="../../../assets/images/noLogin_Bg1.png"> -->
            <div class="noLoginBox">
              <i class="noLoginIcon"></i>
              <p>Log in to view the content.</p>
              <div class="btn" @click="onChangePop({loginShow:true, loginInfoShow:false})">Log in Now</div>
            </div>
          </div>
        </div>
        <div v-else class="noData">
          <div><img src="../../../assets/images/nodata.png" /></div>
          <div class="title">No data</div>
        </div>
      </div>
      <div class="rightBox flex1">
        <div class="title">Additional Matches</div>
        <ul class="list">
          <li v-for="(item,index) in relateMatch" :key="index" @click="changeMatch(item)">
            <div class="flex flex-align-center">
              <div class="logo"><img :src="common.teamImgGet(item['homeTeam']['id'])" @error="common.imgError($event, 'team')"  alt=""></div>
              <div class="name">{{ item.homeTeam.fullName }}</div>
            </div>
            <div class="flex flex-align-center">
              <div class="logo"><img :src="common.teamImgGet(item['awayTeam']['id'])" @error="common.imgError($event, 'team')"  alt=""></div>
              <div class="name">{{ item.awayTeam.fullName }}</div>
            </div>
            <div class="league flex flex-align-center">
              <div class="logo"><img :src="common.leagueImgGet(item['leagueId'])" @error="common.imgError($event, 'team')"  alt=""></div>
              <div class="name">{{relateLeague[item.leagueId]['shortName']}}  {{getGameTime(item.startTime)}}</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <van-popup class="tipPopup" v-model="tipPopupShow" :position="isWeb?'center':'bottom'" round  get-container="#app">
      <div class="popup_head flex flex-align-center">
        <p class="popup_title">Poisson Prediction Instruction</p>
        <i class="popup_close" @click="tipPopupShow = !tipPopupShow"/>
      </div>
      <div class="popup_body">
        <div>
          <div class="popup_body_title">Poisson predictions based on Poisson distribution for match outcomes.</div>
          <ul>
            <li>
              <div class="list_title">Poisson Predicted Final Scores：</div>
              <div>
                <p>Based on Poisson distribution, the "Final Scores" prediction results recommend three scores with the highest probabilities for your reference; Each option below shows the calculated probability, as well as the reference odds for your consideration.</p>
              </div>
            </li>
          </ul>
          <div class="img">
            <img v-if="isWeb == true" src="~@/assets/images/correctScores_poisson_pc.png" />
            <img v-if="isWeb == false" src="~@/assets/images/correctScores_poisson_mb.png" />
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  name: 'correctScores',
  props: {
    detailInfo: {
      type: Object,
      default:null
    }, 
    relateMatch: {
      type: Array,
      default:null
    },
    isLogin: {
      type: Boolean,
      default: false
    },
    match: {
      type: Object,
      default:null
    }, 
    setting: {
      type: Object,
      default: () => {}
    },
    relateLeague: {
      type: [Object,Array],
      default:null
    },
  },
  data(){
    return {
      scoreProbabilityArr: ['1-0','0-0','0-1','2-0','1-1','0-2','2-1','2-2','0-3','3-0','3-3','0-4','3-1','4-4','1-2','3-2','1d','1-3','4-0','','1-4','4-1','','2-3','4-2','','2-4','4-3','','3-4'],
      isWeb: true,
      tipPopupShow: false,
    }
  },
  methods: {
    // 登录传参
    onChangePop(val) {
      let eventName = 'LS_PC_H_Login';
      if(this.common.isMobile != 4){
          eventName = 'LS_Webapp_H_Login';
      }

      this.common.googleEvent(eventName, {
          '触发位置': '比赛内页Scores'
      });

      let _val = val;
      this.$emit('onChangLogin', _val);
    },

    getGameTime(startTime,_dateForm){
      var _tz = '+08:00'
      var _this=this;
      var setting=_this.common.getCookie('setting');  
      // var _dateForm = 'dd MM YYYY HH:mm';
    
      if(setting!=null&&setting!=undefined&&setting){
        setting=JSON.parse(setting);
        _tz=setting.tsz
      }

      var _time=this.common.dateStr(this.common.getDateByArray(_tz, startTime),_dateForm);
      
      var timeArr = _time.split(' ')
      timeArr[1] = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Spt","Oct","Nov","Dec"][timeArr[1]-1]
      _time = timeArr.join(' ')
      return _time;

    },

    // 获取百分比
    percentageVal(a,b,num){
      if(a && b){
        return (((b/a) * 100).toFixed(num||0) || 0) + '%'
      }else{
        return '0%'
      }
    },

    getscoreProbabilityValue(type,item){
      let obj = this.detailInfo.scoreModel.scoreTotalOptions.find(ele => ele.score == item)
      if(type == 'val'){
        if(obj){
          return obj.value
        }else{
          return '';
        }
      }else if(type == 'odds'){
        if(obj){
          return obj.odds != 0 ? obj.odds : '-'
        }else{
          return ''
        }
      }
    },

    // 判断是否命中
    isHit(isHit){
      if(this.match.state == 4){
        if(isHit == 1){
          return 'hit'
        }else{
          return 'noHit'
        }
      }
    },

    //获取屏幕宽度
    handleResize() {
      if(typeof window!='undefined'){
        this.isWeb=(window.innerWidth>767?true:false)
      }
    },

    // 关联比赛
    changeMatch(item){
      let eventName = 'LS_PC_MD_AdditionalMatches_Click';
      if(this.common.isMobile != 4){
          eventName = 'LS_Webapp_MD_AdditionalMatches_Click';
      }
      this.common.googleEvent(eventName, {
        '玩法': this.langConfig.txtLang[this.langConfig.curLang]['PLAY_EVENT'][3]
      });

      let _homeName = this.common.formalTitle(item.homeTeam.fullName)
      let _awayName = this.common.formalTitle(item.awayTeam.fullName)
      if(this.$route.params.id != item.matchId) this.$router.push("/details/" +  this.$route.params.tab + '/' + item.matchId + '/' + _homeName + '-vs-' + _awayName);
    },

    showPopup(){
      if(!this.tipPopupShow){
        let eventName = 'LS_PC_Help_Click';
        if(this.common.isMobile != 4){
            eventName = 'LS_Webapp_Help_Click';
        }

        this.common.googleEvent(eventName, {
            '点击位置': '比赛内页Scores'
        });
      }

      this.tipPopupShow = true
    },
  },
  mounted() {
    let eventName = 'LS_PC_MD_Scores';
    if(this.common.isMobile != 4){
        eventName = 'LS_Webapp_MD_Scores';
    }
    this.common.googleEvent(eventName);

    setTimeout(() => {
      this.handleResize();
    },100)

    this.$nextTick(() => {
      if(typeof window!='undefined'){
        window.addEventListener('resize', this.handleResize);
      }
    })
  },
  beforeDestroy() {
    if(typeof window!='undefined'){
      window.removeEventListener('resize', this.handleResize);
    }
  },
}
</script>
<style scoped lang="less"> 
  @import 'correctScores.less';  
</style>


// WEBPACK FOOTER //
// ./src/views/details/components/correctScores.vue